const AuthorInfo = {
	dev: {
		name: 'Debajyoti Karmaker',
		image: 'dev.jpg',
		link: 'https://cecs.anu.edu.au/people/debajyoti-karmaker'
	},
	ingo: {
		name: 'Ingo Schiffner',
		image: 'ingo.jpg',
		link: 'http://huji.move-ecol.com/users/ingo-schiffner'
	},
	michael: {
		name: 'Michael Wilson',
		image: 'michael.jpg',
		link: 'https://www.linkedin.com/in/michael-j-wilson/'
	},
	srini: {
		name: 'Mandyam V Srinivasan',
		image: 'srini.jpg',
		link: 'https://qbi.uq.edu.au/profile/613/srini-srinivasan'
	},
	julia: {
		name: 'Julia Groening',
		image: 'julia2.jpg',
		link: 'https://www.linkedin.com/in/julia-groening-313a30183/'
	},
	hong: {
		name: 'Hong Vo',
		image: 'hong.jpg',
		link: 'https://qbi.uq.edu.au/profile/937/hong-vo'
	},
	tim: {
		name: 'Timothy L Molloy',
		image: 'tim.jpg',
		link: 'https://www.linkedin.com/in/tlmolloy/'
	},
	grace: {
		name: 'Grace S Garden',
		image: 'grace.jpg',
		link: 'https://www.linkedin.com/in/grace-garden/'
	},
	tristan: {
		name: 'Tristan Perez',
		image: 'tristan.png',
		link: 'https://www.linkedin.com/in/tristan-perez-b463584/'
	},
	abhijit: {
		name: 'Abhijit Bhowmik',
		image: 'abhijit.jpg',
		link: 'http://cs.aiub.edu/profile/abhijit'
	},
	nabila: {
		name: 'Nashia Ahmed Nabila',
		image: 'nabila.jpg',
		link: 'https://fst.aiub.edu/people/faculty-members'
	},
	imran: {
		name: 'Al Imran',
		image: 'imran.jpg',
		link: 'https://www.linkedin.com/in/alimran2401/'
	},
	saef: {
		name: 'Mohammad Saef Ullah Miah',
		image: 'saef.jpg',
		link: 'https://www.linkedin.com/in/mohammad-saef-ullah-miah-08912b71/'
	},
	mohaiminul: {
		name: 'Mohammad Mohaiminul Islam',
		image: 'mohaiminul.jpg',
		link: 'https://www.linkedin.com/in/iammohaiminul/'
	},
	nafees: {
		name: 'Nafees Mahbub',
		image: 'nafees.jpg',
		link: 'https://www.linkedin.com/in/nafees-mahbub-7223b657/'
	},
	niaj: {
		name: 'Niaj Mohammad',
		image: 'niaj.jpg',
		link: 'https://www.linkedin.com/in/niaj-mohammad-4039a560/'
	},
	saied: {
		name: 'Mohammad Saiedur Rahaman',
		image: 'saied.jpg',
		link:
			'https://www.rmit.edu.au/contact/staff-contacts/academic-staff/s/saiedur-rahaman-dr-mohammad'
	},
	ripon: {
		name: 'Mohammad Saidur Rahman',
		image: 'ripon.jpg',
		link: 'https://www.researchgate.net/profile/Mohammad_Rahman164/'
	},
	hafiz: {
		name: 'Hafizur Rahman',
		image: 'hafiz.jpg',
		link: 'https://www.researchgate.net/profile/Hafizur_Rahman15'
	},
	nahar: {
		name: 'Nahar Sultana',
		image: 'nahar.jpg',
		link: 'cs.aiub.edu'
	},
	bari: {
		name: 'Md. Kamrul Bari',
		image: 'bari.jpg',
		link: 'https://www.linkedin.com/in/md-kamrul-bari-mipa-afa-1b7221105/'
	},
	reuben: {
		name: 'Reuben Strydom',
		image: 'reuben.jpg',
		link: 'https://www.linkedin.com/in/md-kamrul-bari-mipa-afa-1b7221105/'
	},
	farhad: {
		name: 'Md. Farhad Zaman',
		image: 'farhad.jpg',
		link: 'https://www.linkedin.com/in/farhad-zaman/'
	},
	Samma: {
		name: 'Samma Tasnim Mossarrat',
		image: 'samma.jpg',
		link: 'https://www.linkedin.com/in/sammatasnim/'
	},
	fahad: {
		name: 'Fahad Islam',
		image: 'missing.jpg',
		link: ''
	},
	ehtesham: {
		name: 'A. Z. M. Ehtesham Chowdhury',
		image: 'ehtesham.jpg',
		link: 'https://www.linkedin.com/in/a-z-m-ehtesham-chowdhury-33a65759/'
	},
	zubaer: {
		name: 'Zubaer Alam',
		image: 'zubaer.jpg',
		link: 'https://www.linkedin.com/in/zubaer-alam-4876a666/'
	},
	adil: {
		name: 'Adil Mahmud Choudhury',
		image: 'adil.jpg',
		link: 'https://www.researchgate.net/profile/Adil_Choudhury3'
	},
	sufi: {
		name: 'Sufi Nayemur Rahman',
		image: 'sufi.jpg',
		link: 'https://www.researchgate.net/profile/Sufi_Rahman4'
	},
	asif: {
		name: 'Md. Asif Ur Rahman',
		image: 'asif.jpg',
		link: 'https://www.linkedin.com/in/as-if-ur/'
	},
	abrar: {
		name: 'M. Abrar Fahad',
		image: 'missing.jpg',
		link: ''
	}
};

export default AuthorInfo;
